import React, { useState, useEffect, useCallback } from 'react';
import { Table, notification } from 'antd';
import { formatPrice, formatDate, formatExpectedOnDate } from '../../../../utils/format';
import { apiReceivablesList } from '../../../../api/receivables';
import { Link } from "react-router-dom";
import {InfoCircleOutlined} from "@ant-design/icons";

const ReceivablesList = ({ transactionId, totalAmount}) => {
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [pagination, setPagination] = useState({
    current: 1,
    pageSize: 10,
    total: 0,
  });
  const fetchReceivables = useCallback(async (params = {}) => {
    setLoading(true);
    try {
      const filters = {
        transaction: transactionId,
        page: params.page || 1,
        page_size: params.pageSize || 10,
      };

      const response = await apiReceivablesList(filters);
      setData(response.results || []);
      setPagination(prev => ({
        ...prev,
        total: response.count || 0,
        current: params.page || 1,
      }));
    } catch (error) {
      notification.error({
        message: "Erro",
        description: "Ocorreu um erro ao buscar os recebíveis.",
        placement: "topRight",
      });
    } finally {
      setLoading(false);
    }
  }, [transactionId]);
  useEffect(() => {
    if (transactionId) {
      fetchReceivables();
    }
  }, [transactionId, fetchReceivables]);

  const handleTableChange = (pagination) => {
    fetchReceivables({
      page: pagination.current,
      pageSize: pagination.pageSize,
    });
  };

  const statusMap = {
    paid: <span className="badge badge-success">Confirmada</span>,
    deleted: <span className="badge badge-error">Deletado</span>,
    scheduled: <span className="badge yellow">Agendado</span>,
    pending: <span className="badge orange">Pendente</span>,
    created: <span className="badge orange">Pendente</span>,
    refunded: <span className="badge badge-error">Estornado</span>,
  };

  const renderStatus = (status) => {
    return statusMap[status] || <span className="badge black">Indefinido</span>;
  };

  const columns = [
    {
      title: 'Titular',
      dataIndex: ['receiver_account', 'display_name'],
      key: 'receiver_account'
    },
    {
      title: 'Data de Pagamento',
      dataIndex: 'expected_on',
      key: 'expected_on',
      render: (date) => date ? formatExpectedOnDate(date) : 'N/A',
    },
    {
      title: 'Valor',
      dataIndex: 'amount',
      key: 'amount',
      render: (amount) => formatPrice(amount),
    },
    {
      title: '%',
      dataIndex: 'amount',
      key: 'amount',
      render: (amount) => {
        const percentage = totalAmount ? ((amount / totalAmount) * 100).toFixed(2) : 0;
        return `${percentage}%`;
      },
    },
    {
      title: 'Status',
      dataIndex: 'status',
      key: 'status',
      render: (status) => renderStatus(status),
    },
    {
      title: 'Tipo',
      dataIndex: 'has_split_linked',
      key: 'has_split_linked',
      render: (hasSplit) => hasSplit ? 'Comissão' : 'Venda',
    },
    {
      title: 'Data de Criação',
      dataIndex: 'created_at',
      key: 'created_at',
      render: (date) => date ? formatDate(date) : 'N/A',
    },
    {
      title: '',
      dataIndex: 'id',
      key: 'id',
      render: (id) => (
        <Link to={`/recebivel/${id}`}>
          <InfoCircleOutlined style={{ cursor: "pointer", height: "100%" }} />
        </Link>
      ),
    },
  ];

  if (!data.length && !loading) {
    return <p>Sem agendamentos no momento.</p>;
  }

  return (
    <Table
      columns={columns}
      dataSource={data}
      loading={loading}
      pagination={{
        current: pagination.current,
        total: pagination.total,
        pageSize: pagination.pageSize,
        showSizeChanger: false,
      }}
      onChange={handleTableChange}
      bordered
      rowKey={(record) => record.id}
    />
  );
};

export default ReceivablesList;
